<div class="header-navigation-back" fxLayoutAlign="left">
  <mat-icon data-test="back-arrow-icon" (click)="navigateBack()">arrow_back</mat-icon>
  <span class="title">Shipments History</span>
</div>
@if (!loading) {
  <div class="list-container">
    <!-- search filter -->
    <div class="search-filter-container">
      <div class="search-input-wrapper">
        <mat-form-field appearance="outline" class="search-field">
          <mat-icon matPrefix svgIcon="magnifying-glass" data-test="search"></mat-icon>
          <input
            matInput
            placeholder="Search history..."
            (input)="onSearchInput(searchInput.value)"
            #searchInput
            [value]="currentSearchInput"
            />
        </mat-form-field>
      </div>
      <div class="filter-buttons-group">
        <button mat-flat-button class="filter-btn" (click)="navigateToFilterShipments()" data-test="filter">
          <mat-icon svgIcon="filter"></mat-icon>
          Filter
        </button>
        <button mat-flat-button class="sort-btn" (click)="sortByStatus()" data-test="sort">
          <mat-icon svgIcon="sort"></mat-icon>
          Sort
        </button>
      </div>
    </div>
    <div class="tag-container">
      @for (tag of tagsList; track tag) {
        <div>
          <span>{{ tag }}</span>
        </div>
      }
    </div>
    @if (shipments) {
      @for (shipment of shipments; track shipment) {
        <div>
          <app-shipments-item [shipment]="shipment" [shipmentHistory]="true"></app-shipments-item>
        </div>
      }
    }
    @if (!shipments?.length) {
      <app-no-shipment
        [message]="noShipmentHistory"
        [isShipmentListPage]="true"
        icon="shipments"
        >
      </app-no-shipment>
    }
  </div>
}
